import { useState, useEffect } from "react";
import cargandoCard from "../../../components/cargando-card";
import { useHistory, } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PopUpLoadingComponent from "../../../components/pop-up-loading";
import { ESTILO_BOTON_LISTAR_ATRAS } from "../../../utils/const/estilos-const";
import spinner from "../../../assets/iconos/spinner4.svg";
import { cambiarPassword, } from "../../../api/api-usuario-web";
import { sharedNextPage } from "../../../utils/shared-functions";

export default function ManageAccount() {

    const { t, i18n } = useTranslation();
    // const location = useLocation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [formData, setFormData] = useState({
        password: "",
        confirmarPassword: "",
    });

    const [loading, setLoading] = useState(false);

    const [popUpLoadingVisible, setPopUpLoadingVisible] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const charLimits = {
        password: 32,
        confirmarPassword: 32,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const validar = () => {
        // console.log("validar", formData);
        let result = { error: true, message: "" };
        let message = "";
        if (formData.password.trim().length === 0) {
            message = message + t("alert_must_enter_password") + "\n";
        }
        if (formData.confirmarPassword.trim().length === 0) {
            message = message + t("alert_must_enter_confirm_password") + "\n";
        }
        if (formData.password !== formData.confirmarPassword) {
            message = message + t("alert_passwords_do_not_match") + "\n";
        }
        result.message = message;
        if (message.length === 0) {
            result.error = false;
        }
        return result;
    };

    const handleSave = async () => {
        try {
            const validate = validar();
            // console.log('validate', validate);
            if (validate.error === true) {
                alert(validate.message);
                return;
            }
            const resp = await cambiarPassword(formData);
            if (resp.error === false) {
                alert(t("alert_procesado_correctamente"));
                sharedNextPage("/login", {}, history);
            }
            if (resp.error === true) {
                alert(t("alert_procesado_correctamente") + "\n" + resp.message);
            }
        } catch (err) {
            console.log('handleSave err');
            console.log(err);
        }
    };

    const render = () => {

        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="p-4 ">
                    <h1 className="text-2xl font-semibold text-gray-900">{t("label_manage_account")}</h1>
                    <br />
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3"></div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                            <>
                                <div>
                                    <label className="block text-[#0F3457] font-semibold mb-2">
                                        {t("label_password")}
                                    </label>
                                    <input
                                        type="text"
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("placeholder_enter_password")}
                                        maxLength={charLimits.password}
                                        min={0}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.password?.length}/{charLimits.password}</p>
                                </div>
                                <div>
                                    <label className="block text-[#0F3457] font-semibold mb-2">
                                        {t("label_confirmar_password")}
                                    </label>
                                    <input
                                        type="text"
                                        id="confirmarPassword"
                                        name="confirmarPassword"
                                        value={formData.confirmarPassword}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={t("placeholder_enter_confirm_password")}
                                        maxLength={charLimits.confirmarPassword}
                                        min={0}
                                    />
                                    <p className="text-sm text-gray-500 flex justify-end">{formData.confirmarPassword?.length}/{charLimits.confirmarPassword}</p>
                                </div>
                                <br />
                                <div className=" flex items-center justify-between">
                                    <button
                                        type="button"
                                        className={ESTILO_BOTON_LISTAR_ATRAS}
                                        onClick={(handleAtrasClick)}
                                    >
                                        {t("label_back")}
                                    </button>
                                    {loading === false &&
                                        <button
                                            className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                            onClick={handleSave}
                                        >
                                            Guardar
                                        </button>
                                    }
                                    {loading === true &&
                                        <button
                                            className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                                        >
                                            <img className="spinner" alt="spinner" src={spinner} />
                                        </button>

                                    }
                                </div>
                            </>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3"></div>
                    </div>
                    <br />
                    <PopUpLoadingComponent
                        isOpen={popUpLoadingVisible}
                    />
                </div>
            );
        } catch (err) {
            console.log('ManageAccount render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
};

